import { INITIAL_INVENTORY_COUNT_ITEMS_SEARCH_PARAMS } from 'src/views/inventory-count/partials/Constants'
import { SET_INVENTORY_COUNT_ITEMS_SEARCH_PARAMS } from '../actions/actionType'

const initialState = {
  inventoryCountItems: [],
  searchParams: INITIAL_INVENTORY_COUNT_ITEMS_SEARCH_PARAMS,
}

export default function InventoryCountItemsReducer(state = initialState, action) {
  switch (action.type) {
    case SET_INVENTORY_COUNT_ITEMS_SEARCH_PARAMS:
      return { ...state, searchParams: action.payload }
    default:
      return state
  }
}
